import { Module } from 'vuex';
import { PropertiesService, PropertiesResponse } from '../../core/api/services/properties.service';

export interface PropertiesState {
    properties: PropertiesResponse | null;
    loading: boolean;
}

export const propertiesModule: Module<PropertiesState, any> = {
    namespaced: true,
    state: {
        properties: null,
        loading: false
    },
    
    mutations: {
        SET_PROPERTIES(state, properties: PropertiesResponse) {
            state.properties = properties;
        },
        SET_LOADING(state, loading: boolean) {
            state.loading = loading;
        }
    },
    
    actions: {
        async loadProperties({ commit, state }) {
            // Don't reload if already loaded
            if (state.properties) {
                return state.properties;
            }

            commit('SET_LOADING', true);
            try {
                const properties = await PropertiesService.getProperties();
                commit('SET_PROPERTIES', properties);
                return properties;
            } catch (error) {
                console.error('Error loading properties:', error);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        }
    },
    
    getters: {
        claimEventTypes: (state) => state.properties ? state.properties.claim_event_types : {},
        cropTypes: (state) => state.properties ? state.properties.crop_types : {},
        getEventTypeName: (state) => (eventType: number) => {
            if (eventType === undefined || eventType === null) return '';
            if (!state.properties) return eventType.toString();
            return state.properties.claim_event_types[eventType.toString()] || eventType.toString();
        },
        getCropTypeName: (state) => (cropType: number) => {
            if (cropType === undefined || cropType === null) return '';
            if (!state.properties) return cropType.toString();
            return state.properties.crop_types[cropType.toString()] || cropType.toString();
        }
    }
};

